import React from 'react';
import ProjectSearchInput from './ProjectSearchInput.jsx';

export default function ProjectManagementSearch({ projectSearch }) {
  return (
    <div className="flare-project-management-search">
      <ProjectSearchInput mode="directory" autoFocus label="搜索项目" search={projectSearch} />
    </div>
  );
}
